import { SharedWith } from "src/apps/AppFlow/pages";
import { Page } from "src/components/FlowLayout";
import { PageState } from "src/hooks/usePageState";
import { Applicant } from "src/types/Applicant";
import { AssetDetailsValue } from "src/types/Application";

import { formatters, parsers } from "@fraction/shared";

import { AssetDetails } from "./pages";

const { FINANCIAL_ASSET_TYPE_MAP } = formatters.enums;

export interface AssetPagesArgs {
  assetDetails: PageState<AssetDetailsValue>;
  applicant?: Applicant;
  otherApplicants?: Applicant[];
  owners: PageState<Applicant[]>;
  onComplete: () => void;
}

const AssetPages = ({ applicant, assetDetails, otherApplicants, owners }: AssetPagesArgs): Page[] => {
  const possessiveFirstName = formatters.user.possessive(parsers.user.parseName(applicant?.name || "").first);

  return [
    {
      name: "assetDetails",
      component: <AssetDetails {...assetDetails} title={`Tell us about ${possessiveFirstName} asset.`} />,
    },
    otherApplicants?.length &&
      applicant && {
        name: "owners",
        component: (
          <SharedWith
            otherApplicants={otherApplicants || []}
            applicant={applicant}
            sharedItemName={`${
              assetDetails.value?.type
                ? FINANCIAL_ASSET_TYPE_MAP[assetDetails.value?.type].toLowerCase()
                : "asset"
            }`}
            {...owners}
          />
        ),
      },
  ].filter((p): p is Page => Boolean(p));
};

export default AssetPages;
